import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  // Add scroll animation detection
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.features-section, .how-it-works-section, .coming-soon-section, .cta-section');
      const animatedElements = document.querySelectorAll('.feature-card, .step, .coming-soon-feature');
      
      const checkVisibility = (elements) => {
        elements.forEach(el => {
          const rect = el.getBoundingClientRect();
          const windowHeight = window.innerHeight || document.documentElement.clientHeight;
          const isVisible = rect.top <= windowHeight * 0.85;
          
          if (isVisible) {
            el.classList.add('visible');
          }
        });
      };
      
      // Check visibility for sections and elements
      checkVisibility(sections);
      checkVisibility(animatedElements);
    };
    
    // Initial check on load
    setTimeout(handleScroll, 300);
    
    // Add scroll listener
    window.addEventListener('scroll', handleScroll);
    
    // Clean up
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="landing-page public-page-content">
      {/* Add the electrical current elements */}
      <div className="current-1"></div>
      <div className="current-2"></div>
      <div className="current-3"></div>
      <div className="current-4"></div>
      <div className="current-5"></div>
      
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Mind Cloning Technology</h1>
          <p className="hero-subtitle">Create an AI-powered mind clone that thinks and speaks like you</p>
          <div className="hero-actions">
            <Link to="/auth" className="primary-button">Start Your Journey</Link>
            <Link to="/pricing" className="secondary-button">View Pricing</Link>
          </div>
        </div>
      </section>

      {/* Neural network background */}
      <div className="neural-network-animation"></div>

      {/* Features Section */}
      <section className="features-section">
        <h2>How Deus Works</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🧠</div>
            <h3>Mind Cloning</h3>
            <p>Deus creates a digital copy of your mind, from how you think to how you speak, and then powers your mind clone with Artificial Intelligence.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💬</div>
            <h3>The Infinite Interview</h3>
            <p>Answer questions to level up your mind clone. Character profiles are generated as you hit various milestones, analyzing what you say and how you say it.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔄</div>
            <h3>Train & Test</h3>
            <p>Switch between training mode and chat mode to continuously improve your mind clone's accuracy and capabilities.</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <h2>The Journey of Your Mind Clone</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Create Your Mind</h3>
            <p>Set up your mind clone with a name that represents how you want to appear to others.</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Train Through Interviews</h3>
            <p>Answer questions from various AI interviewers to help your clone understand your thought patterns.</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Test in Chat Mode</h3>
            <p>Switch to chat mode to interact with your mind clone and see how accurately it represents you.</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Continuously Improve</h3>
            <p>Return to training to refine your clone further as you reach new milestones.</p>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="coming-soon-section">
        <h2>Coming Soon</h2>
        <div className="coming-soon-features">
          <div className="coming-soon-feature">
            <span className="feature-badge">Social</span>
            <p>Release your agent into the world-wide-web</p>
          </div>
          <div className="coming-soon-feature">
            <span className="feature-badge">Deus Friend</span>
            <p>Multimodal conversations with your agents</p>
          </div>
          <div className="coming-soon-feature">
            <span className="feature-badge">Infinite Backrooms</span>
            <p>Autonomous agent to agent conversations</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Digitize Your Mind?</h2>
        <p>Join the next generation of AI technology and experience your digital twin.</p>
        <Link to="/auth" className="primary-button">Get Started Now</Link>
      </section>
    </div>
  );
}

export default LandingPage; 